function formatCurrency(currency: string, total: number) {
  return new Intl.NumberFormat(navigator.language, { style: 'currency', currency, maximumFractionDigits: 10 }).format(total);
}

function formatNumbersByLang(total: number) {
  return new Intl.NumberFormat(navigator.language).format(total);
}

export { formatCurrency, formatNumbersByLang };
